module.exports = __webpack_public_path__ + "static/media/hamburger.a4a5dc02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/hamburger.svg
// module id = 805
// module chunks = 2